(function () {
  'use strict';

  var STATUS_LABEL_KEYS = {
    SCHEDULED: 'statusScheduled',
    OPEN: 'statusOpen',
    CLOSED: 'statusClosed',
    DRAWING: 'statusDrawing',
    RESULTS: 'statusResults'
  };

  function setText(element, value) {
    if (element) element.textContent = value == null ? '' : String(value);
  }

  function createNode(tag, className, content) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    setText(element, content);
    return element;
  }

  function normalizePlayerId(value) {
    var id = String(value || '').trim();
    return /^\d+$/.test(id) && id.length <= 20 ? id : '';
  }

  function boot(root) {
    var api = root.dataset.apiBase;
    var explicitSlug = root.dataset.slug;
    var seriesSlug = root.dataset.seriesSlug;
    var currentSlug = explicitSlug;
    var previousResultSlug = null;
    var nextGiveaway = null;
    var refreshInFlight = null;
    var renderedSlug = null;
    var refreshVersion = 0;
    var deadlineTimer = null;
    var sessionToken = readSessionToken();
    var labels = JSON.parse(root.querySelector('[data-giveaway-labels]').textContent);
    var content = root.querySelector('[data-giveaway-content]');
    var loading = root.querySelector('[data-giveaway-loading]');
    var errorPanel = root.querySelector('[data-giveaway-error]');
    var inactivePanel = root.querySelector('[data-giveaway-inactive]');
    var message = root.querySelector('[data-giveaway-message]');
    var inlineError = root.querySelector('[data-giveaway-inline-error]');
    var playerIdInput = root.querySelector('[data-player-id]');
    var uniqueIdState = window.EightBpUniqueId;

    if (uniqueIdState && !playerIdInput.uniqueIdController) {
      uniqueIdState.enhance(playerIdInput, {
        source: 'giveaway',
        container: playerIdInput.parentElement,
        label: playerIdInput.dataset.uniqueIdLabel,
        clearLabel: playerIdInput.dataset.uniqueIdClearLabel,
        closeLabel: playerIdInput.dataset.uniqueIdCloseLabel,
        recentLabel: playerIdInput.dataset.uniqueIdRecentLabel
      });
    }

    function readSessionToken() {
      try {
        return localStorage.getItem('bbhubGiveawaySession');
      } catch (_) {
        return null;
      }
    }

    function saveSessionToken(value) {
      try {
        localStorage.setItem('bbhubGiveawaySession', value);
      } catch (_) {}
    }

    function request(path, options) {
      var headers = options && options.body ? { 'Content-Type': 'application/json' } : {};
      if (sessionToken) headers.Authorization = 'Bearer ' + sessionToken;
      return fetchReadSafe(api + path, Object.assign({ credentials: 'omit', headers: headers }, options || {}))
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            if (!response.ok) {
              var error = new Error(body.error || labels.error);
              error.code = body.code || '';
              error.status = response.status;
              throw error;
            }
            return body;
          });
        });
    }

    function fetchReadSafe(url, options, attempt) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 12000);
      var safe = !options.method || options.method === 'GET';
      return fetch(url, Object.assign({}, options, { signal: controller.signal }))
        .then(function (response) {
          if (safe && [502, 503, 504].indexOf(response.status) !== -1) throw new Error(labels.error);
          return response;
        }).catch(function (error) {
          if (safe && !attempt) return new Promise(function (resolve) { setTimeout(resolve, 400); })
            .then(function () { return fetchReadSafe(url, options, 1); });
          if (error.name === 'TypeError' || error.name === 'AbortError') throw new Error(labels.error);
          throw error;
        }).finally(function () { clearTimeout(timer); });
    }

    function setBusy(button, busy, busyText) {
      if (!button) return;
      var label = button.querySelector('[data-button-label]');
      var spinner = button.querySelector('.loading-overlay__spinner');
      if (!button.dataset.idleText) button.dataset.idleText = (label || button).textContent.trim();
      button.disabled = busy;
      button.setAttribute('aria-busy', String(busy));
      if (spinner) spinner.classList.toggle('hidden', !busy);
      setText(label || button, busy && busyText ? busyText : button.dataset.idleText);
    }

    function translatedError(error) {
      var byCode = {
        connections_required: labels.connectionsRequired,
        already_entered: labels.alreadyEntered,
        giveaway_not_open: labels.notOpen,
        invalid_player_id: labels.invalidPlayerId
      };
      return byCode[error && error.code] || (error && error.message) || labels.error;
    }

    function clearMessages() {
      inlineError.hidden = true;
      message.hidden = true;
      setText(message.querySelector('.product-form__success-message'), '');
    }

    function showInlineError(error) {
      message.hidden = true;
      inlineError.hidden = false;
      setText(
        inlineError.querySelector('.product-form__error-message'),
        translatedError(error)
      );
    }

    function showStatus(value) {
      inlineError.hidden = true;
      message.hidden = false;
      setText(message.querySelector('.product-form__success-message'), value);
    }

    function formatDate(value, timezone) {
      try {
        return new Intl.DateTimeFormat(root.dataset.locale, {
          dateStyle: 'full',
          timeStyle: 'short',
          timeZone: timezone
        }).format(new Date(value));
      } catch (_) {
        return new Date(value).toLocaleString();
      }
    }

    function createCountdown(host, value) {
      if (!host) return;
      host.replaceChildren();
      if (!value || new Date(value).getTime() <= Date.now()) return;

      var template = document.createElement('template');
      template.innerHTML = '<count-down class="single-countdown giveaway__countdown" data-time="' +
        new Date(value).toISOString() + '">' +
        '<div><span data-countdown-unit="day"></span><div data-days></div></div>' +
        '<div><span data-countdown-unit="hours"></span><div data-hours></div></div>' +
        '<div><span data-countdown-unit="minutes"></span><div data-minutes></div></div>' +
        '<div><span data-countdown-unit="seconds"></span><div data-seconds></div></div>' +
        '</count-down>';
      Object.keys(labels).forEach(function (key) {
        var unit = template.content.querySelector('[data-countdown-unit="' + key + '"]');
        if (unit) setText(unit, labels[key]);
      });
      host.appendChild(template.content);
    }

    function scheduleDeadlineRefresh(data) {
      if (deadlineTimer) window.clearTimeout(deadlineTimer);
      var now = Date.now();
      var next = [data.opensAt, data.closesAt, nextGiveaway && nextGiveaway.opensAt]
        .filter(Boolean)
        .map(function (value) { return new Date(value).getTime(); })
        .filter(function (value) { return value > now; })
        .sort(function (a, b) { return a - b; })[0];
      if (!next) return;
      deadlineTimer = window.setTimeout(refresh, Math.min(next - now + 1500, 2147480000));
    }

    function renderTiming(data) {
      var target;
      var countdownLabel;
      var exactLabel;
      if (data.status === 'SCHEDULED') {
        target = data.opensAt;
        countdownLabel = labels.startsIn;
        exactLabel = labels.startsAt;
      } else if (data.status === 'OPEN') {
        target = data.closesAt;
        countdownLabel = labels.closesIn;
        exactLabel = labels.closesAt;
      } else if (data.status === 'CLOSED' || data.status === 'DRAWING') {
        target = data.closesAt;
        countdownLabel = labels.statusDrawing;
        exactLabel = labels.closesAt;
      } else if (nextGiveaway) {
        target = nextGiveaway.opensAt;
        countdownLabel = labels.nextStartsIn;
        exactLabel = labels.startsAt;
      } else {
        target = data.closesAt;
        countdownLabel = labels.statusResults;
        exactLabel = labels.closesAt;
      }
      setText(root.querySelector('[data-giveaway-countdown-label]'), countdownLabel);
      setText(root.querySelector('[data-giveaway-exact-time]'), exactLabel + ': ' + formatDate(target, data.timezone));
      createCountdown(root.querySelector('[data-giveaway-countdown]'), target);
      scheduleDeadlineRefresh(data);
    }

    function rewardAmount(reward) {
      return reward.finalAmount == null ? reward.baseAmount : reward.finalAmount;
    }

    function renderPrizeCards(container, rewards, showCalculation) {
      if (!container) return;
      var fragment = document.createDocumentFragment();
      (rewards || []).forEach(function (reward) {
        var card = createNode('div', 'giveaway__prize');
        if (reward.imageUrl) {
          var imageWrap = createNode('div', 'giveaway__prize-media image-container');
          var image = document.createElement('img');
          image.src = reward.imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          image.width = 88;
          image.height = 88;
          image.onerror = function () { imageWrap.remove(); };
          imageWrap.appendChild(image);
          card.appendChild(imageWrap);
        }
        var copy = createNode('div', 'giveaway__prize-copy');
        copy.appendChild(createNode('strong', '', rewardAmount(reward).toLocaleString(root.dataset.locale) + ' ' + reward.name));
        if (showCalculation) {
          var detail = reward.calculation === 'FIXED'
            ? labels.fixedReward
            : labels.baseReward + ': ' + reward.baseAmount.toLocaleString(root.dataset.locale) +
              (reward.multiplier ? ' · ×' + reward.multiplier : '');
          copy.appendChild(createNode('span', '', detail));
        }
        card.appendChild(copy);
        fragment.appendChild(card);
      });
      container.replaceChildren(fragment);
    }

    function renderLinks(rules) {
      var links = [
        ['[data-discord-open]', rules && rules.discord, labels.openDiscord],
        ['[data-telegram-open]', rules && rules.telegram, labels.openTelegram],
        ['[data-whatsapp-open]', rules && rules.whatsapp],
        ['[data-youtube-open]', rules && rules.youtube],
        ['[data-instagram-open]', rules && rules.instagram]
      ];
      links.forEach(function (item) {
        var element = root.querySelector(item[0]);
        var rule = item[1];
        if (!element || !rule || !rule.url) return;
        element.href = rule.url;
        if (item[2]) setText(element, item[2]);
        element.hidden = false;
      });
    }

    function renderConnections(state) {
      var discordConnected = Boolean(state.discord && state.discord.connected);
      root.querySelector('[data-discord-start]').hidden = discordConnected;
      root.querySelector('[data-discord-connection]').hidden = !discordConnected;
      setText(
        root.querySelector('[data-discord-state]'),
        discordConnected ? labels.connectedAs + ' ' + (state.discord.username || 'Discord') : ''
      );

      var telegramLinked = Boolean(state.telegram && state.telegram.linked);
      var telegramVerified = Boolean(state.telegram && state.telegram.connected);
      root.querySelector('[data-telegram-start]').hidden = telegramLinked;
      root.querySelector('[data-telegram-connection]').hidden = !telegramLinked;
      root.querySelector('[data-telegram-verify]').hidden = !telegramLinked || telegramVerified;
      setText(
        root.querySelector('[data-telegram-state]'),
        telegramLinked
          ? (telegramVerified ? labels.connectedAs : labels.linkedNotVerified) + ' ' + (state.telegram.username || 'Telegram')
          : ''
      );
      setStepComplete('discord', discordConnected);
      setStepComplete('telegram', telegramVerified);
    }

    function stepStorageKey(step) {
      return 'bbhubGiveawayStep:' + (seriesSlug || currentSlug || explicitSlug) + ':' + step;
    }

    function readStepComplete(step) {
      try { return localStorage.getItem(stepStorageKey(step)) === '1'; } catch (_) { return false; }
    }

    function setStepComplete(step, complete) {
      var item = root.querySelector('[data-giveaway-step="' + step + '"]') ||
        (step === 'youtube' || step === 'instagram'
          ? root.querySelector('[data-giveaway-step="youtube-instagram"]')
          : null);
      if (!item) return;
      item.classList.toggle('is-complete', complete);
    }

    function rememberStep(step) {
      try { localStorage.setItem(stepStorageKey(step), '1'); } catch (_) {}
      if (step === 'youtube' || step === 'instagram') {
        setStepComplete('youtube-instagram', readStepComplete('youtube') && readStepComplete('instagram'));
      } else {
        setStepComplete(step, true);
      }
    }

    function resetEntryProgress() {
      ['whatsapp', 'youtube', 'instagram'].forEach(function (step) {
        try { localStorage.removeItem(stepStorageKey(step)); } catch (_) {}
      });
      setStepComplete('whatsapp', false);
      setStepComplete('youtube-instagram', false);
      playerIdInput.removeAttribute('aria-invalid');
    }

    function renderConfirmed(data) {
      var panel = root.querySelector('[data-giveaway-confirmed]');
      var form = root.querySelector('[data-giveaway-entry-form]');
      var entryInput = root.querySelector('[data-giveaway-entry-input]');
      var entry = data.entry;
      var entered = Boolean(entry && entry.status === 'ACTIVE');
      if (panel) panel.hidden = !entered;
      if (form) form.hidden = false;
      if (entryInput) entryInput.hidden = entered;
      if (!entered) return;
      setText(root.querySelector('[data-giveaway-confirmed-player]'), entry.playerId || '—');
      setText(root.querySelector('[data-giveaway-confirmed-entry]'), data.participantCount.toLocaleString(root.dataset.locale));
      renderPrizeCards(root.querySelector('[data-giveaway-confirmed-rewards]'), entry.rewardPreview && entry.rewardPreview.rewards, true);
    }

    function refreshSession() {
      return request('/session', { method: 'POST' }).then(function (state) {
        if (state.sessionToken) {
          sessionToken = state.sessionToken;
          saveSessionToken(sessionToken);
        }
        renderConnections(state);
        return state;
      });
    }

    function renderNext(data) {
      var section = root.querySelector('[data-next-giveaway]');
      if (!section) return;
      section.hidden = !data;
      if (!data) return;
      setText(root.querySelector('[data-next-giveaway-title]'), data.title);
      renderPrizeCards(root.querySelector('[data-next-giveaway-prizes]'), data.rewards, false);
    }

    function render(data) {
      renderedSlug = data.slug;
      loading.hidden = true;
      errorPanel.hidden = true;
      inactivePanel.hidden = true;
      content.hidden = false;
      setText(root.querySelector('[data-giveaway-title]'), data.title);
      setText(root.querySelector('[data-giveaway-description]'), data.description);
      setText(root.querySelector('[data-giveaway-status]'), labels[STATUS_LABEL_KEYS[data.status]] || data.status);
      setText(root.querySelector('[data-giveaway-count]'), data.participantCount);
      setText(root.querySelector('[data-participant-count]'), data.participantCount);
      setText(root.querySelector('[data-giveaway-winner-count]'), data.winnerCount);
      renderTiming(data);
      renderLinks(data.rules);

      var giveawayImage = root.querySelector('[data-giveaway-image]');
      var giveawayImageElement = root.querySelector('[data-giveaway-image-element]');
      giveawayImage.hidden = !data.imageUrl;
      if (data.imageUrl) {
        giveawayImageElement.onerror = function () { giveawayImage.hidden = true; };
        giveawayImageElement.src = data.imageUrl;
        giveawayImageElement.alt = data.title || '';
      } else {
        giveawayImageElement.removeAttribute('src');
      }

      renderPrizeCards(root.querySelector('[data-giveaway-prizes]'), data.rewards, true);
      root.querySelectorAll('[data-giveaway-entry]').forEach(function (section) {
        section.hidden = data.status !== 'OPEN';
      });
      root.querySelector('[data-giveaway-submit]').hidden = Boolean(data.entry && data.entry.status === 'ACTIVE');
      root.querySelector('[data-giveaway-withdraw]').hidden = !data.entry || data.entry.status !== 'ACTIVE';
      renderConfirmed(data);
      root.querySelector('[data-giveaway-results]').hidden = !data.participants;
      if (data.participants) renderResults(data, false);
      renderNext(nextGiveaway);
    }

    function renderResults(data, previous) {
      var results = root.querySelector('[data-giveaway-results]');
      results.hidden = false;
      if (results.dataset.round !== data.slug) results.open = !previous;
      results.dataset.round = data.slug;
      setText(root.querySelector('[data-results-round]'), new Date(data.closesAt).toLocaleDateString(root.dataset.locale) + ' · ' + data.rewards.map(function (reward) { return rewardAmount(reward).toLocaleString(root.dataset.locale) + ' ' + reward.name; }).join(' + '));
      setText(root.querySelector('[data-participant-count]'), data.participantCount);

      var participants = root.querySelector('[data-giveaway-participants]');
      participants.replaceChildren();
      (data.participants || []).forEach(function (participant) {
        participants.appendChild(createNode('li', '', participant.playerId));
      });

      var winners = root.querySelector('[data-giveaway-winners]');
      winners.replaceChildren();
      if (!data.winners.length) {
        winners.appendChild(createNode('p', 'giveaway__empty', data.status === 'RESULTS'
          ? '0 ' + labels.winners
          : labels.statusDrawing));
        return;
      }
      data.winners.forEach(function (winner) {
        winners.appendChild(createNode(
          'div',
          'giveaway__winner',
          '#' + winner.position + ' · ' + (winner.discordDisplayName ? winner.discordDisplayName + ' · ' : '') + winner.playerId + ' — ' + winner.rewards.map(function (reward) {
            return reward.amount.toLocaleString(root.dataset.locale) + ' ' + reward.name;
          }).join(' + ')
        ));
      });
    }

    function resolveRound() {
      if (!seriesSlug) return Promise.resolve();
      return fetchReadSafe(
        api.replace(/\/giveaways$/, '/giveaway-series') + '/' + encodeURIComponent(seriesSlug),
        { credentials: 'omit' }
      ).then(function (response) {
        if (!response.ok) {
          var error = new Error(labels.error);
          error.status = response.status;
          throw error;
        }
        return response.json();
      }).then(function (result) {
        currentSlug = result.giveawaySlug;
        previousResultSlug = result.previousResultSlug;
        nextGiveaway = result.nextGiveaway;
      });
    }

    function showError(error) {
      if (error && error.status === 404) {
        if (deadlineTimer) {
          window.clearTimeout(deadlineTimer);
          deadlineTimer = null;
        }
        renderedSlug = null;
        loading.hidden = true;
        content.hidden = true;
        errorPanel.hidden = true;
        inactivePanel.hidden = false;
        return;
      }
      inactivePanel.hidden = true;
      if (renderedSlug) { showInlineError(error); return; }
      loading.hidden = true;
      content.hidden = true;
      errorPanel.hidden = false;
      setText(
        errorPanel.querySelector('.product-form__error-message'),
        translatedError(error)
      );
    }

    function refresh() {
      if (refreshInFlight) return refreshInFlight;
      var version = ++refreshVersion;
      refreshInFlight = resolveRound().then(function () {
        if (!currentSlug) throw new Error(labels.error);
        return request('/' + encodeURIComponent(currentSlug) + '?preview=deferred');
      }).then(function (data) {
        render(data);
        if (data.entry) {
          var entrySlug = data.slug;
          request('/' + encodeURIComponent(entrySlug)).then(function (updated) {
            if (renderedSlug === entrySlug && version === refreshVersion) renderConfirmed(updated);
          }).catch(function () {});
        }
        if (!data.participants && previousResultSlug) {
          var slug = data.slug;
          request('/' + encodeURIComponent(previousResultSlug)).then(function (previous) {
            if (renderedSlug === slug && version === refreshVersion) renderResults(previous, true);
          }).catch(function () {});
        }
      }).catch(showError).finally(function () { refreshInFlight = null; });
      return refreshInFlight;
    }

    function disconnect(provider, button) {
      setBusy(button, true);
      clearMessages();
      request('/session', {
        method: 'DELETE',
        body: JSON.stringify({ provider: provider })
      }).then(renderConnections).catch(function (error) {
        showInlineError(error);
      }).finally(function () {
        setBusy(button, false);
      });
    }

    root.querySelector('[data-giveaway-retry]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      setBusy(button, true);
      errorPanel.hidden = true;
      loading.hidden = false;
      refresh().finally(function () { setBusy(button, false); });
    });

    root.querySelector('[data-discord-start]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      var popup = window.open('about:blank', '_blank');
      if (popup) popup.opener = null;
      setBusy(button, true);
      request('/discord/start', {
        method: 'POST',
        body: JSON.stringify({ returnTo: window.location.href })
      }).then(function (result) {
        if (result.sessionToken) {
          sessionToken = result.sessionToken;
          saveSessionToken(sessionToken);
        }
        if (popup) popup.location.replace(result.url);
        else window.location.href = result.url;
      }).catch(function (error) {
        if (popup) popup.close();
        showInlineError(error);
      }).finally(function () {
        setBusy(button, false);
      });
    });

    root.querySelector('[data-telegram-start]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      var popup = window.open('about:blank', '_blank');
      if (popup) popup.opener = null;
      setBusy(button, true);
      request('/telegram/start', { method: 'POST' }).then(function (result) {
        if (result.sessionToken) {
          sessionToken = result.sessionToken;
          saveSessionToken(sessionToken);
        }
        if (popup) popup.location.replace(result.url);
        else window.location.href = result.url;
      }).catch(function (error) {
        if (popup) popup.close();
        showInlineError(error);
      }).finally(function () {
        setBusy(button, false);
      });
    });

    root.querySelector('[data-telegram-verify]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      setBusy(button, true);
      request('/telegram/verify', { method: 'POST' })
        .then(refreshSession)
        .catch(showInlineError)
        .finally(function () { setBusy(button, false); });
    });

    root.querySelector('[data-discord-disconnect]').addEventListener('click', function (event) {
      disconnect('discord', event.currentTarget);
    });
    root.querySelector('[data-telegram-disconnect]').addEventListener('click', function (event) {
      disconnect('telegram', event.currentTarget);
    });
    root.querySelector('[data-giveaway-submit]').addEventListener('click', function (event) {
      var playerId = normalizePlayerId(playerIdInput.value);
      if (!playerId) {
        playerIdInput.setAttribute('aria-invalid', 'true');
        showInlineError({ code: 'invalid_player_id' });
        playerIdInput.focus();
        return;
      }
      var button = event.currentTarget;
      var query = new URLSearchParams(window.location.search);
      setBusy(button, true, labels.entering);
      clearMessages();
      request('/' + encodeURIComponent(currentSlug) + '/entry', {
        method: 'POST',
        body: JSON.stringify({
          playerId: playerId,
          attribution: {
            utmSource: query.get('utm_source') || undefined,
            utmMedium: query.get('utm_medium') || undefined,
            utmCampaign: query.get('utm_campaign') || undefined,
            landingUrl: window.location.href,
            referrer: document.referrer || undefined
          }
        })
      }).then(function (result) {
        if (uniqueIdState) uniqueIdState.set(playerId, { source: 'giveaway', persist: true, remember: true });
        showStatus(labels.entrySubmitted);
        return refresh();
      }).catch(function (error) {
        showInlineError(error);
      }).finally(function () {
        setBusy(button, false);
      });
    });

    ['whatsapp', 'youtube', 'instagram'].forEach(function (step) {
      var link = root.querySelector('[data-' + step + '-open]');
      if (!link) return;
      if (step === 'youtube' || step === 'instagram') {
        setStepComplete('youtube-instagram', readStepComplete('youtube') && readStepComplete('instagram'));
      } else if (readStepComplete(step)) {
        setStepComplete(step, true);
      }
      link.addEventListener('click', function () { rememberStep(step); });
    });

    root.querySelector('[data-giveaway-withdraw]').addEventListener('click', function (event) {
      var button = event.currentTarget;
      var modal = root.querySelector('[data-withdraw-modal]');
      if (typeof jq_lumia === 'undefined' || !jq_lumia.fancybox) { showInlineError({ message: labels.error }); return; }
      modal.id = modal.id || 'giveaway-withdraw-' + Math.random().toString(36).slice(2);
      var instance = jq_lumia.fancybox.open({ src: '#' + modal.id, type: 'inline' }, {
        autoFocus: true,
        backFocus: true,
        afterClose: function () {
          var confirm = modal.querySelector('[data-withdraw-confirm]');
          confirm.onclick = null;
          confirm.disabled = false;
        }
      });
      if (!instance) { showInlineError({ message: labels.error }); return; }
      modal.querySelector('[data-withdraw-confirm]').onclick = function () {
        if (this.disabled) return;
        this.disabled = true;
        instance.close();
        withdrawEntry(button);
      };
    });

    function withdrawEntry(button) {
      setBusy(button, true);
      clearMessages();
      request('/' + encodeURIComponent(currentSlug) + '/entry', { method: 'DELETE' }).then(function () {
        resetEntryProgress();
        showStatus(labels.withdrawn);
        return refresh();
      }).catch(showInlineError)
        .finally(function () { setBusy(button, false); });
    }

    playerIdInput.addEventListener('input', function () {
      playerIdInput.removeAttribute('aria-invalid');
      clearMessages();
    });
    window.addEventListener('focus', function () {
      refreshSession().catch(function () {});
    });

    var connectionResult = new URLSearchParams(window.location.search).get('giveaway_connection');
    if (connectionResult) {
      if (connectionResult === 'discord-connected') showStatus(labels.discordConnected);
      else showInlineError({ message: labels.discordConnectionError });
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('giveaway_connection');
      window.history.replaceState({}, '', cleanUrl.toString());
    }

    refresh();
    refreshSession().catch(function () {});
    window.setInterval(refresh, 60000);
  }

  document.querySelectorAll('[data-giveaway]').forEach(function (root) {
    try {
      boot(root);
    } catch (error) {
      var loading = root.querySelector('[data-giveaway-loading]');
      var errorPanel = root.querySelector('[data-giveaway-error]');
      if (loading) loading.hidden = true;
      if (errorPanel) {
        errorPanel.hidden = false;
        setText(
          errorPanel.querySelector('.product-form__error-message'),
          error && error.message ? error.message : 'Unable to load giveaway.'
        );
      }
    }
  });
})();
